import { Close } from '@mui/icons-material';
import { Grid, Typography, IconButton } from '@mui/material';
import { FC } from 'react';

export type TModalHeaderProps = {
  title: string;
  onClose: () => void;
  styles?: React.CSSProperties;
};

const ModalHeader: FC<TModalHeaderProps> = ({
  title,
  onClose,
  styles = {},
  ...other
}) => {
  return (
    <Grid
      item
      xs={12}
      data-testid="modal-header"
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: {
          xs: '56px',
          sm: 'var(--modal-header-height)',
        },
        borderBottom: '1px solid var(--border_grey)',
        px: {
          xs: 2,
          sm: 3,
          md: 4,
        },
        ...styles,
      }}
      {...other}
    >
      <Typography 
        variant="h6"
        sx={{
          fontSize: {
            xs: '1rem',
            sm: '1.25rem',
          },
          fontWeight: {
            xs: 600,
            sm: 500,
          },
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1,
          pr: 1,
        }}
      >
        {title}
      </Typography>
      <IconButton 
        onClick={onClose}
        data-testid="modal-close-button"
        sx={{
          minWidth: { xs: '44px', sm: '40px' },
          minHeight: { xs: '44px', sm: '40px' },
          padding: { xs: '8px', sm: '4px' },
        }}
      >
        <Close />
      </IconButton>
    </Grid>
  );
};

export default ModalHeader;
